import { render, staticRenderFns } from "./ActivityTabNotes.vue?vue&type=template&id=3b7cc0eb&"
import script from "./ActivityTabNotes.vue?vue&type=script&lang=js&"
export * from "./ActivityTabNotes.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTabNotes.vue?vue&type=style&index=0&id=3b7cc0eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports